/**
 * @desc addByReturn
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.OutMasterLendCreateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
